export default {"src":"/_next/static/media/task-list.02124e3d.svg","height":50,"width":44,"blurWidth":0,"blurHeight":0};